import apiClient from "../axios";

export const useApi = () => {
  return { client: apiClient };
};
